/* src/app/contract/contract-list/contract-list.component.css */
:host ::ng-deep .p-datatable .p-datatable-thead > tr > th {
  max-width: 250px;
  text-overflow: ellipsis;
  white-space: nowrap;
}
/*# sourceMappingURL=contract-list.component-HSMTAZBA.css.map */
